
import {Component, Prop, Vue} from 'vue-property-decorator'

@Component
export default class TextExcerpt extends Vue {
  @Prop(String) text!: string
}
